import CustomTab from "./customTab";
import ButtonTab from "./buttonTab";

export { ButtonTab };

export default CustomTab;
